import { render } from "./Fonts.vue?vue&type=template&id=2070a0a0&scoped=true"
import script from "./Fonts.vue?vue&type=script&lang=js"
export * from "./Fonts.vue?vue&type=script&lang=js"

import "./Fonts.vue?vue&type=style&index=0&id=2070a0a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2070a0a0"]])

export default __exports__